// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"So-z","breadcrumbForward":"To-z","breadcrumbBack":"Uo-z","selected":"Vo-z"};